import { render, staticRenderFns } from "./rutaSitio.vue?vue&type=template&id=529d74fa"
import script from "./rutaSitio.vue?vue&type=script&lang=js"
export * from "./rutaSitio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports